/** THIS FILE IS AUTOGENERATED. DO NOT EDIT. */
import { IconProps } from "../types";
const ArrowTrendingDownIcon = ({
  size = 24,
  ...props
}: IconProps) => {
  return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width={size} height={size} {...props}><path fillRule="evenodd" d="M2.505 6.306a1.043 1.043 0 0 1 1.476 0l5.103 5.103 3.157-3.156a1.043 1.043 0 0 1 1.475 0l6.008 6.007V8.99a1.043 1.043 0 1 1 2.086 0v7.788c0 .576-.467 1.044-1.043 1.044h-7.788a1.043 1.043 0 1 1 0-2.086h5.27l-5.27-5.27-3.157 3.156a1.043 1.043 0 0 1-1.475 0L2.505 7.78a1.043 1.043 0 0 1 0-1.475" clipRule="evenodd" /></svg>;
};
export default ArrowTrendingDownIcon;